export default {
  pageTitle: 'Certification',
  metaDescription: 'TEF holds ASME U and R Stamp, National Board, ISO 9001:2015, MIGAS and EBTKE certifications, ensuring our fabrication meets international quality standards.',
  hero: { title: 'Certification' },
  certSection: {
    heading: 'Certification and Standards',
    intro: 'We have acquired the following quality certifications:',
    otherCodesIntro: 'Additionally, we can comply with other Pressure Vessel Codes, such as :',
    otherCodes: {
      japanese: 'Japanese Code',
    },
  },
};
